import React, { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  Col,
  Grid,
  Icon,
  Title,
} from '@common/components';
import { faChartColumn, faTable } from '@fortawesome/free-solid-svg-icons';
import { ChartFactory } from '@dashboard/components/ChartFactory';
import { DataGridFactory } from '@dashboard/components/DataGridFactory';
import PropTypes from 'prop-types';

import classes from './ChartStat.module.scss';

export default function ChartStat({ title, stat }) {
  const [visualization, setVisualization] = useState('chart');

  return (
    <div>
      <Grid justify="space-between" className={classes.chartTitle}>
        <Col>
          <Title type="h2" color="primary">
            {title}
          </Title>
        </Col>
        <Col>
          <Grid>
            <Button
              variant="raised"
              color={visualization === 'chart' ? 'accent' : 'white'}
              className={classes.chartVisualizationButton}
              onClick={() => setVisualization('chart')}
            >
              <Icon icon={faChartColumn} />
            </Button>

            <Button
              variant="raised"
              color={visualization === 'grid' ? 'accent' : 'white'}
              className={classes.chartVisualizationButton}
              onClick={() => setVisualization('grid')}
            >
              <Icon icon={faTable} />
            </Button>

            <Button
              variant="raised"
              color={visualization === 'chart-and-grid' ? 'accent' : 'white'}
              className={classes.chartVisualizationButton}
              onClick={() => setVisualization('chart-and-grid')}
            >
              <Icon icon={faChartColumn} /> + <Icon icon={faTable} />
            </Button>
          </Grid>
        </Col>
      </Grid>
      <Card className={classes.chart}>
        <CardContent className={classes.chartContent}>
          {['chart', 'chart-and-grid'].includes(visualization) && (
            <ChartFactory data={stat} type={stat.type} />
          )}
          {['grid', 'chart-and-grid'].includes(visualization) && (
            <DataGridFactory data={stat} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}

ChartStat.propTypes = {
  title: PropTypes.node,
  stat: PropTypes.object.isRequired,
};
